module.exports = "https://beta.voredev.ru/assets/index/whatsapp-mini-ac1104fae3096548adb9f71f2830bc25.svg";